export const rootMenu: { label: string, url: string, roles: string[], feature?: string }[] = [
    {
        label: 'Home',
        url: '/',
        roles: []
    },
    {
        label: 'Warehousing',
        url: '/warehousing',
        roles: [ 'scs site user', 'scs admin', 'scs accounting', 'payroll', 'it', 'developers' ]
    },
    {
        label: 'Pallet Solutions',
        url: '/pallet-solutions',
        roles: [ 'ps site user', 'ps site admin', 'payroll', 'it', 'developers' ],
    },
    {
        label: 'Reports',
        url: '/reports',
        roles: []
    },
    {
        label: 'Administration',
        url: '/admin',
        roles: [ 'scs admin', 'scs accounting', 'payroll', 'it', 'developers' ]
    },
    {
        label: 'Corporate',
        url: '/corporate',
        roles: [ 'risk management', 'scs accounting', 'scs admin', 'ps admin', 'payroll', 'it', 'developers', 'ai' ],
    },
    {
        label: 'Mobile',
        url: '/mobile',
        roles: [ 'scs site qa', 'scs site admin', 'scs admin', 'it', 'developers' ],
    }/*,
    {
        label: 'Useful Links',
        url: '/#/useful-links',
    }*/
];
